import { render, staticRenderFns } from "./LogLink.vue?vue&type=template&id=52a8cc1a&scoped=true&"
import script from "./LogLink.vue?vue&type=script&lang=js&"
export * from "./LogLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8cc1a",
  null
  
)

export default component.exports